import * as serviceTemplateModel from '~/models/service-template';
import { Accounting } from '~/types/accounting';
import { helpArticles } from '~/utils/helpArticles';
import pluralize from '~/utils/pluralize';
import { accountingFullName } from './accounting-names';
import { QboIntegrationPolicy, XeroIntegrationPolicy } from './accounting-policy';
const qboItem = 'service';
const xeroItem = 'item';
export const getAccountingDetails = (accounting)=>({
        fullName: accountingFullName[accounting],
        name: ({
            [Accounting.QBO]: 'QuickBooks',
            [Accounting.Xero]: 'Xero'
        })[accounting],
        shortName: ({
            [Accounting.QBO]: 'QBO',
            [Accounting.Xero]: 'Xero'
        })[accounting],
        item: ({
            [Accounting.QBO]: qboItem,
            [Accounting.Xero]: xeroItem
        })[accounting],
        items: ({
            [Accounting.QBO]: pluralize(qboItem),
            [Accounting.Xero]: pluralize(xeroItem)
        })[accounting],
        helpArticle: ({
            [Accounting.QBO]: {
                setup: helpArticles.qboSetup(),
                contactMapping: helpArticles.qboSetup('contact-mapping'),
                servicesMapping: helpArticles.qboSetup('services-mapping'),
                reactivateItems: helpArticles.qboReactivateItems(),
                unlinkPayment: helpArticles.qboUnlinkPayment(),
                accountPeriodClosed: helpArticles.qboAccountPeriodClosed(),
                changeInvoicePrefix: helpArticles.qboChangeInvoicePrefix(),
                taxMapping: helpArticles.salesTaxMapping()
            },
            [Accounting.Xero]: {
                setup: helpArticles.xeroSetup(),
                contactMapping: helpArticles.xeroContactMapping(),
                servicesMapping: helpArticles.xeroServicesMapping(),
                reactivateItems: helpArticles.xeroReactivateItems(),
                unlinkPayment: helpArticles.xeroSetup(),
                accountPeriodClosed: helpArticles.xeroSetup(),
                changeInvoicePrefix: helpArticles.xeroChangeInvoicePrefix(),
                taxMapping: helpArticles.salesTaxMapping()
            }
        })[accounting],
        testIdPrefix: ({
            [Accounting.QBO]: 'qbo',
            [Accounting.Xero]: 'xero'
        })[accounting],
        biCodes: ({
            [Accounting.QBO]: {
                mapContacts: 12001,
                mapServices: 12002,
                disconnect: 12003,
                linkContact: 12004,
                unlinkContact: 12005,
                linkService: 12006,
                unlinkService: 12007,
                resumeConnection: 12008,
                chooseAccounts: 12010,
                linkAccountToPaymentAccount: 12011,
                linkAccount: 12012,
                pushNewContact: 12014
            },
            [Accounting.Xero]: {
                mapContacts: 12021,
                mapServices: 12022,
                disconnect: 12023,
                linkContact: 12024,
                unlinkContact: 12025,
                linkService: 12026,
                unlinkService: 12027,
                resumeConnection: 12028,
                chooseAccounts: 12030,
                linkAccountToPaymentAccount: 12031,
                linkAccount: 12032,
                pushNewContact: 12034
            }
        })[accounting],
        policy: ({
            [Accounting.QBO]: new QboIntegrationPolicy(),
            [Accounting.Xero]: new XeroIntegrationPolicy()
        })[accounting]
    });
export const getServiceTemplateMapStatus = (param)=>{
    let { accounting, serviceTemplate, accountingItems } = param;
    const integratedId = serviceTemplateModel.integratedId({
        serviceTemplate,
        accounting
    });
    const accountingItem = accountingItems.find((item)=>item.id === integratedId);
    if (integratedId && accountingItem) {
        return 'mapped';
    }
    if (integratedId && !accountingItem) {
        return 'failedToMap';
    }
    return 'notMapped';
};
